<template>
  <div class="works">
    <div class="works_title public"></div>
    <div class="works_top_left" v-if="ism == 'M'">
      今日剩余点赞次数：<span>{{ lickNum }}</span>
    </div>
    <div class="works_top">
      <div class="works_top_left" v-if="ism == 'PC'">
        今日剩余点赞次数：<span>{{ lickNum }}</span>
      </div>
      <div class="works_top_right">
        <div class="works_top_right_searchbox public">
          <el-input
            v-model="searcinput"
            @change="getworksList"
            placeholder="搜索"
          ></el-input>
        </div>
        <div class="works_top_right_btn">
          <div
            :class="minhot_btn"
            class="staicminbtn public"
            @click="worksTopChange(1)"
          >
            最热
          </div>
          <div
            :class="minnow_btn"
            class="staicminbtn public"
            @click="worksTopChange(2)"
          >
            最新
          </div>
        </div>
      </div>
    </div>
    <div class="works_changebtn">
      <div :class="herobtn" class="staicbtn public" @click="worksHeroChange(1)">
        英雄皮肤
      </div>
      <div
        :class="soldiersbtn"
        class="staicbtn public"
        @click="worksHeroChange(2)"
      >
        士兵皮肤
      </div>
    </div>
    <div class="works_listbox">
      <div class="grid">
        <div
          class="grid-item works_list"
          v-for="item in worksList"
          :key="item.id"
        >
          <div class="works_imgtop public"></div>
          <div class="works_img" @click="tipchange(item)">
            <img :src="item.m_info.thumbnail_url" />
          </div>
          <div class="works_imgbottom public">
            <div class="works_imgbottom_top">作品名：{{ item.m_name }}</div>
            <div class="works_imgbottom_bottom public">
              <div class="works_imgbottom_bottom_left">
                作者：{{ item.author_name }}
              </div>
              <div
                class="works_imgbottom_bottom_right"
                @click="lickClick(item)"
              >
                {{ item.like_num }}
              </div>
            </div>
          </div>
        </div>
        <!-- <div>到底啦</div> -->
      </div>
    </div>
  </div>
</template>
<script>
import http from "../../api/http";
import * as _code from "../../utils/code.js";
import qs from "qs";
import Masonry from "masonry-layout";
import imagesloaded from "imagesloaded";
import {
  getScrollHeight,
  getScrollTop,
  getWindowHeight,
} from "../../utils/screen";
export default {
  name: "works",
  props: {
    ism: {
      type: String,
      default: "",
    },
    role_id: {
      type: String,
      default: "",
    },
    endFlag: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      works_type: 9, //作品皮肤切换
      works_order_type: 0, //作品最新最热切换
      worksPage: 0,
      lickNum: 0,
      waterfall_num: 4,
      worksList: [],
      worksList1: [],
      worksListFlag: true,
      minhot_btn: "minbtn",
      minnow_btn: "minbtn",
      herobtn: "currbtn",
      soldiersbtn: "btn",
      searcinput: "",
    };
  },
  mounted() {
    // this.getworksList();
    window.addEventListener("scroll", this.load);
  },
  destroyed() {
    window.removeEventListener("scroll", this.load, false);
  },
  watch: {
    searcinput(ne) {
      this.worksListFlag = true;
    },
    role_id(ne) {
      this.getworksList();
    },
  },
  methods: {
    lickClick(items, e) {
      //点赞
      if (this.endFlag) {
        this.$emit("promptTip", true, 3, "", "活动已结束！");
        return;
      }
      if (this.role_id) {
        let obj = {
          id: items.id,
          roleid: this.role_id,
          type: this.works_type,
        };
        http.lick(qs.stringify(obj)).then((res) => {
          let data = res.data;
          if (data.info == 1) {
            if (e) {
              this.$message("感谢指挥官！相信画师已经收到了您的鼓励~");
            } else {
              this.$emit(
                "promptTip",
                true,
                3,
                "点赞成功",
                "感谢指挥官！相信画师已经收到了您的鼓励~"
              );
            }
            this.worksList.forEach((item, index) => {
              if (item.id == items.id) {
                item.like_num++;
              }
            });
            this.lickNum--;
            this.$emit("lickAdd", items);
            // this.getworksList();
          } else {
            let code = data.info;
            let voteErr = _code.code.vote;
            let msg = voteErr[code] ? voteErr[code] : voteErr["other"] + code;
            if (e) {
              this.$message(msg);
            } else {
              this.$emit("promptTip", true, 3, "点赞失败", msg);
            }
          }
        });
      } else {
        if (e) {
          this.$message("您还未登录哦，请登录后再进行点赞吧~");
        } else {
          this.$emit(
            "promptTip",
            true,
            3,
            "点赞失败",
            "您还未登录哦，请登录后再进行点赞吧~"
          );
          this.$emit("loginflagChang");
        }
      }
    },
    getworksList(e, skin, order) {
      //获取作品列表
      let _this = this;
      if (skin) {
        if (this.works_type != skin) {
          this.worksPage = 1;
          _this.worksListFlag = true;
        }
        this.works_type = skin;
      }
      if (order) {
        if (this.works_order_type != order) {
          this.worksPage = 1;
          _this.worksListFlag = true;
        }
        this.works_order_type = order;
      }
      if (this.worksListFlag) {
        if (e == "add") {
          this.worksPage++;
        }
        if (this.searcinput) {
          let obj = {
            appkey: 1486458782785,
            type: this.works_type,
            order_type: this.works_order_type,
            pageNumber: 1,
            pageCounts: 20,
            key: this.searcinput,
          };
          http.search(qs.stringify(obj)).then((res) => {
            res.data.data.list.forEach((item, index) => {
              item.m_info = JSON.parse(item.m_info);
            });
            _this.$nextTick(function () {
              _this.worksList = [...res.data.data.list];
            });
            if (res.data.data.list.length < 20) {
              _this.worksListFlag = false;
            }
          });
        } else {
          let obj = {
            appkey: 1486458782785,
            type: this.works_type,
            order_type: this.works_order_type,
            pageNumber: this.worksPage,
            roleid: this.role_id,
            pageCounts: 20,
          };
          http.getList(qs.stringify(obj)).then((res) => {
            this.lickNum = res.data.data.remainLikeNum;
            if (_this.worksPage == 1) {
              res.data.data.list.forEach((item, index) => {
                item.m_info = JSON.parse(item.m_info);
              });
              _this.$nextTick(function () {
                _this.worksList = res.data.data.list;
              });
              if (res.data.data.list.length < 20) {
                _this.worksListFlag = false;
              }
            } else {
              res.data.data.list.forEach((item, index) => {
                item.m_info = JSON.parse(item.m_info);
              });
              _this.$nextTick(function () {
                _this.worksList = [..._this.worksList, ...res.data.data.list];
              });
              if (res.data.data.list.length < 20) {
                _this.worksListFlag = false;
              }
            }
          });
        }
      }
    },
    load() {
      //无限滚动加载
      let vm = this;
      if (vm.ism == "M") {
        if (getScrollTop() + getWindowHeight() >= getScrollHeight() - 100) {
          this.getworksList("add");
        }
      } else {
        if (getScrollTop() + getWindowHeight() >= getScrollHeight()) {
          this.getworksList("add");
        }
      }
    },
    tipchange(item) {
      this.$emit("tipchange", true, 1, item.id);
    },
    worksTopChange(id) {
      if (id == 1) {
        this.minhot_btn = "mincurrbtn";
        this.minnow_btn = "minbtn";
        this.getworksList("", "", 1);
      } else {
        this.minhot_btn = "minbtn";
        this.minnow_btn = "mincurrbtn";
        this.getworksList("", "", 2);
      }
    },
    worksHeroChange(id) {
      if (id == 1) {
        this.herobtn = "currbtn";
        this.soldiersbtn = "btn";
        this.getworksList("", "9");
      } else {
        this.herobtn = "btn";
        this.soldiersbtn = "currbtn";
        this.getworksList("", "10");
      }
    },
  },
  updated() {
    //瀑布流初始
    var grid = document.querySelector(".grid");
    var msnry = new Masonry(grid, {
      itemSelector: ".grid-item",
      // gutter: 10,
      columnWidth: 3,
    });
    imagesloaded(".grid-item", () => {
      msnry.layout(); // 图片加载完成后重新绘制。
    });
  },
};
</script>
<style scoped>
</style>